module.exports = __webpack_public_path__ + "assets/img/xinxiku.c836123d.png";